import { SelectedWorkspaceCtx } from "../../../contexts/SelectedWorkspaceCtx";
import { disableButton, enableButton, openCrispChat } from "../../../lib/utility";
import { requestFeatureService } from "../../../services/requestFeatureService";
import { addToast } from "../../../toasts";

export function WebhookSetup() {
  let $submitButton: null | HTMLButtonElement = null;
  let $chatWithUs: null | HTMLButtonElement = null;

  function init() {
    $submitButton = document.getElementById("request-webhook-btn") as HTMLButtonElement;
    $chatWithUs = document.getElementById("chat-with-us-webhook") as HTMLButtonElement;
    let $formData: null | FormData = null;
    const { selectedWorkspace } = SelectedWorkspaceCtx;

    $formData = new FormData();
    if (selectedWorkspace) $formData.append("workspace_id", selectedWorkspace.unique_workspace_id);
    $formData.append("reference_page", window.location.pathname.substring(1));
    $formData.append("reference_popup", "My Account");

    $submitButton?.addEventListener("click", async () => {
      if ($formData) {
        disableButton($submitButton!);
        try {
          const response: any = await requestFeatureService.requestFeature("webhook_setup", $formData);
          addToast({ toastBody: response.message }, "default", "success");
          enableButton($submitButton!);
        } catch (error: any) {
          console.error("Update account details request failed: ", error);
          addToast({ toastBody: error.message }, "default", "error");
          enableButton($submitButton!);
        }
      }
    })

    $chatWithUs?.addEventListener("click", () => {
      openCrispChat();
    })
  }

  function render() {
    return /*html*/`<div id="vertical-tab-myaccount-webhooks" class="hidden" role="tabpanel" aria-labelledby="vertical-tab-myaccount-webhooks">
                      <!-- Account Card -->
                      <div class="p-4 md:p-5 bg-white border border-gray-200 shadow-sm rounded-xl dark:bg-neutral-800 dark:border-neutral-700 md:min-h-[calc(100vh-90px)]">
                        <!-- Title -->
                        
                        <div class="flex justify-between gap-x-3 mb-3 xl:mb-6">
                          <div>
                            <h3 class="text-lg font-semibold text-gray-800 dark:text-neutral-200">
                              Webhook Setup
                            </h3>
                            <p class="text-sm text-gray-500 dark:text-neutral-500">
                              Get data out of Feedspace to your system in real time using Webhook
                            </p>
                          </div>
                          <!-- End Col -->
                        </div>

                        <!-- Card -->
                        <div class="py-8 px-5 relative overflow-hidden text-center bg-white border border-transparent rounded-xl dark:bg-neutral-800">
                            <div class="relative z-10">
                              <div class="text-center mb-4">
                                <img src="/images/Webhook-Setup.svg" alt="Empty State" class="mx-auto">
                              </div>
                              <p class="text-gray-500 dark:text-neutral-500 mx-auto max-w-md">
                                Feedspace currently has outgoing webhook to bring data into your system from Feedspace. It's paid users. Please click below to request the access.
                              </p>
                              <div class="mb-0 sm:my-5 mt-3">
                                <button type="button" id="request-webhook-btn" class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:ring-2 focus:ring-blue-500" data-hs-overlay="#hs-pro-dshm">
                                <span class="btn-label flex gap-x-1 items-center">    
                                Request Webhook Access
                                </span>
                                </button>
                              </div>
                              <h6 class="my-3 font-semibold	text-lg text-gray-800	dark:text-neutral-200">OR</h6>
                              <div class="sm:mt-5">
                                <button type="button" id="chat-with-us-webhook" class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-50 dark:bg-neutral-800 dark:border-neutral-700 dark:text-neutral-300 dark:hover:bg-neutral-700 dark:focus:bg-neutral-700" data-hs-overlay="#hs-pro-dshm">
                                    Chat with us
                                </button>
                              </div>
                            </div>
                        </div>
                        <!-- End Card -->        

                      </div>
                      <!-- End Title -->
                    </div>`;
  }

  return {
    render,
    init
  }
}